import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipmentStatus } from '../../enums';
import { ShipmentStatusPipe } from '../../pipes';

@Component({
  selector: 'app-shipment-status',
  imports: [CommonModule, ShipmentStatusPipe],
  templateUrl: './shipment-status.component.html',
  styleUrl: './shipment-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentStatusComponent {
  public readonly withColors = input(false);
  public readonly status = input.required<ShipmentStatus>();

  protected readonly cssClass = computed(() => {
    if (!this.withColors()) {
      return '';
    }

    switch (this.status()) {
      case ShipmentStatus.Cancelled:
        return 'text-red-600';

      case ShipmentStatus.Deleted:
        return 'text-gray-500';

      case ShipmentStatus.Sent:
        return 'text-green-600';

      case ShipmentStatus.Pending:
        return 'text-emerald-700';

      default:
        return '';
    }
  });
}
